import './mediaCard.scss';
import { Icon } from '@rocketmakers/armstrong';
import * as React from 'react';
import { Card } from '../layout/card';
import { VideoOverlay } from './videoOverlay';
export const MediaCard = ({ icon, text, downloadSrc, vimeoId }) => {
    const [overlayOpen, setOverlayOpen] = React.useState(false);
    const onClickMediaCard = React.useCallback(() => {
        if (vimeoId) {
            setOverlayOpen(true);
        }
    }, [vimeoId]);
    return (<>
      <Card className="media-card" onClick={onClickMediaCard} to={downloadSrc} download={!!downloadSrc}>
        <Icon {...icon}/>
        <p>{text}</p>
      </Card>

      <VideoOverlay vimeoId={vimeoId} isOpen={overlayOpen} onClose={() => setOverlayOpen(false)} analyticsId={`Media Card ---> ${text} `}/>
    </>);
};
